import { render, staticRenderFns } from "./RecipeIconTiny.vue?vue&type=template&id=05c64834&scoped=true"
import script from "./RecipeIconTiny.vue?vue&type=script&lang=js"
export * from "./RecipeIconTiny.vue?vue&type=script&lang=js"
import style0 from "./RecipeIconTiny.vue?vue&type=style&index=0&id=05c64834&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c64834",
  null
  
)

export default component.exports